<template>
    <form-wrapper
        :linkedForm="linkedForm"
        :redirection="redirectionTo"
        :store="store"
        :current="current"
        :labelSaveAndAction="labelSaveAndAction"
        @catch-errors="catchErrors"
    >
        <template slot="title">{{ formTitle }}</template>

        <!-- THE COMPANY -->
        <form-fields-wrapper
            :field="'company'"
            :toggleAllowed="false"
            :title="$t.__('common.labels.the_company')"
            v-if="!isSingle && hasCompany && companyHasName"
        >
            <form-fields-companies-list class="mt-3" :company="company" />
        </form-fields-wrapper>

        <!-- CONTACT -->
        <form-fields-wrapper
            field="contact"
            :toggleAllowed="false"
            :title="$t.__('pages.forms.ThirdContactForm.contact')"
        >
            <form-fields-contact
                ref="main"
                :currentStore="current"
                :error="error.errors"
            ></form-fields-contact>
        </form-fields-wrapper>

        <!-- CUSTOM FIELDS -->
        <form-fields-wrapper
            field="custom-fields"
            :toggleAllowed="false"
            :title="$t.__('pages.forms.ThirdContactForm.contact_custom_fields')"
        >
            <form-fields-custom-fields
                ref="custom-fields"
                :currentStore="current"
                :error="error.errors"
                :currentCustomfields="getCustomFields"
            ></form-fields-custom-fields>
        </form-fields-wrapper>
    </form-wrapper>
</template>

<script>
import FormWrapper from 'vcomponents/forms/FormWrapper.vue';
import FormFieldsWrapper from 'vcomponents/forms/FormFieldsWrapper.vue';
import FormFieldsContact from 'vcomponents/thirds/thirdscomponents/FormFieldsContact.vue';
import FormFieldsCompaniesList from 'vcomponents/thirds/thirdscomponents/FormFieldsCompaniesList.vue';
import FormFieldsCustomFields from 'vcomponents/thirds/thirdscomponents/FormFieldsCustomFields.vue';
import contactModule from 'stores/forms/contact';
import companyModule from 'stores/forms/company';

export default {
    props: {
        linkedContact: {
            type: Object,
            required: false,
        },
        linkedForm: {
            type: Object,
            required: false,
            default: null,
        },
    },
    components: {
        FormFieldsContact,
        FormFieldsWrapper,
        FormWrapper,
        FormFieldsCompaniesList,
        FormFieldsCustomFields,
    },
    data() {
        return {
            current: 'contactForm',
            store: contactModule,
            from: companyModule,
            redirectionTo: 'people.overview',
            formTitle: this.$l10n.__('Ajouter un nouveau contact'),
            error: {},
        };
    },
    created() {
        //Avoid duplication of store
        if (!this.$store.state.contactForm) {
            this.$store.registerModule(this.current, this.store);
        }
        if (this.linkedContact && this.linkedContact.contactSettings) {
            if (this.linkedForm?.new) {
                //contact from search company
                this.$store.commit(
                    `${this.current}/setName`,
                    this.linkedContact.contactSettings.name,
                );
                this.$store.commit(
                    `${this.current}/setForename`,
                    this.linkedContact.contactSettings.forename,
                );
                this.$store.commit(
                    `${this.current}/setRole`,
                    this.linkedContact.contactSettings.role,
                );
                this.$store.commit(`${this.current}/setIsLinkedContact`, true);
            } else {
                //contact with manual method
                this.$store.commit(`${this.current}/setContact`, this.linkedContact);
            }
        }
    },
    beforeDestroy() {
        this.$store.unregisterModule(this.current);
    },
    computed: {
        getCustomFields() {
            return _.isNil(this.linkedContact?.contactSettings?.customFields)
                ? []
                : [...this.linkedContact.contactSettings.customFields];
        },
        labelSaveAndAction() {
            return true
                ? this.$l10n.__('Enregistrer et ajouter un autre contact')
                : this.$l10n.__('Enregistrer et ajouter un autre contact sur la societé');
        },
        isSingle() {
            if (this.linkedForm && _.isNil(this.linkedForm.name)) {
                return true;
            }
            return false;
        },
        company() {
            if (this.hasCompany) {
                document.querySelector('#sellsy_app').scrollTo(0, 0);
                return {
                    address: {
                        city: this.linkedForm.state.addresses[0].settings?.city || '',
                        postal_code: this.linkedForm.state.addresses[0].settings?.postalCode || '',
                    },
                    name: this.linkedForm.state.companySettings.name,
                };
            }
        },
        companyHasName() {
            return _.isNil(this.linkedForm.state.companySettings.name) ? false : true;
        },
        hasCompany() {
            return this.linkedForm && Object.values(this.linkedForm.state).length > 0
                ? true
                : false;
        },
    },
    methods: {
        catchErrors(err) {
            this.error = err ? err : [{}];
        },
    },
};
</script>
